import classNames from 'classnames';
import React from 'react';
import styles from "./card-description.module.css";
/** React prop interface for `CardDescription` component */

/**
 * ### CardDescription
 */
export const CardDescription = _ref => {
  let {
    className,
    children
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: classNames('ud-text-md', styles.description, className)
  }, children);
};
//# sourceMappingURL=card-description.react-component.js.map